import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { DisableControlDirective } from '../directives/disable-control.directive';
import { PromisableButtonDirective } from '../directives/promisable-button.directive';
import { FindPipe } from '../pipes/find.pipe';
import { NullableNumberPipe } from '../pipes/nullable-number.pipe';
import { UomPipe } from '../pipes/uom.pipe';

@NgModule({
  declarations: [
    UomPipe,
    FindPipe,
    NullableNumberPipe,
    DisableControlDirective,
    PromisableButtonDirective
  ],
  imports: [CommonModule],
  exports: [
    UomPipe,
    FindPipe,
    NullableNumberPipe,
    DisableControlDirective,
    PromisableButtonDirective
  ],
  providers: [
    UomPipe,
    DecimalPipe
  ],
})
export class CoreModule { }
